import _ from 'underscore';
import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { withContextualAttributeTemplate } from '@bingads-webui-campaign/recommendation-contextual-attribute';
import { CONTEXTUAL_ENTITY_TYPE } from '@bingads-webui-campaign/recommendation-core';
import recommendedAdTemplate from './preview-improve-mma-column.pug';

export class PreviewImproveMMAColumn extends CampaignuiBaseColumn {
  constructor({
    deps = {
      adDisplayUrlService: null,
      combineText: null,
    },
    scope,
    i18n,
    newI18n,
  }) {
    const title = newI18n.getString(_TL_('Multimedia ads recommendations'));

    super({
      name: 'PreviewdMMA',
      property: 'PreviewdMMA',
      title,
      sortable: false,
      type: 'string',
      bodyClasses: ['suggested-improve-mma-preview-column'],
      colClasses: ['mma-col-ads-preview'],
      helpAriaLabel: title,
    });

    this.scope = scope;
    this.deps = deps;
    this.i18n = i18n;
    this.newI18n = newI18n;
  }

  pickProperty(recommendation) {
    const { newI18n } = this;
    const opportunity = recommendation.Opportunities[0];
    const { OpportunityType } = opportunity;

    const {
      Images,
    } = opportunity;

    let {
      Headline,
      Description,
    } = opportunity;

    const {
      Headlines,
      Descriptions,
      LongHeadlines,
    } = opportunity;

    Headline = _.result(_.first(Headlines), 'Text') || Headline;
    Description = _.result(_.first(Descriptions), 'Text') || Description;

    let landscapeImageMediaUrl = '';
    if (!_.isEmpty(Images)) {
      const image = _.first(Images);
      if (_.isNull(image.AssetIdString)) {
        landscapeImageMediaUrl = image.ThumbnailURL;
      } else {
        let imageUrlToUse = image.ImageURL;

        // strip off the resizing from MT as we need a smaller resizing
        const indexOfResizeInfo = imageUrlToUse.indexOf('&w=');
        if (indexOfResizeInfo > 0) {
          imageUrlToUse = imageUrlToUse.substr(0, indexOfResizeInfo);
        }

        const responsiveAdThumbnailWidth = 114;
        const responsiveAdThumbnailHeight = 60;
        const resizeQueryString = `&w=${responsiveAdThumbnailWidth}&h=${responsiveAdThumbnailHeight}`;

        landscapeImageMediaUrl = `${imageUrlToUse}${resizeQueryString}`;
      }
    }

    const numberOfSuggestedImage = _.filter(Images, image => _.isNull(image.AssetId)).length;
    const numberOfSuggestedHeadline =
      _.filter(Headlines, headline => _.isNull(headline.AssetId)).length
      + _.filter(LongHeadlines, longHeadline => _.isNull(longHeadline.AssetId)).length;
    let numberOfSuggestedImageHeadline;

    if (numberOfSuggestedImage >= 0 && numberOfSuggestedHeadline >= 0) {
      if (numberOfSuggestedImage === 1 && numberOfSuggestedHeadline === 1) {
        numberOfSuggestedImageHeadline
        = newI18n.getString(
            _TL_('Suggested additional {{numberOfSuggestedImage}} image and {{numberOfSuggestedHeadline}} headline'),
            { numberOfSuggestedImage, numberOfSuggestedHeadline }
          );
      } else if (numberOfSuggestedImage === 1 && numberOfSuggestedHeadline > 1) {
        numberOfSuggestedImageHeadline
        = newI18n.getString(
            _TL_('Suggested additional {{numberOfSuggestedImage}} image and {{numberOfSuggestedHeadline}} headlines'),
            { numberOfSuggestedImage, numberOfSuggestedHeadline }
          );
      } else if (numberOfSuggestedImage > 1 && numberOfSuggestedHeadline === 1) {
        numberOfSuggestedImageHeadline
        = newI18n.getString(
            _TL_('Suggested additional {{numberOfSuggestedImage}} images and {{numberOfSuggestedHeadline}} headline'),
            { numberOfSuggestedImage, numberOfSuggestedHeadline }
          );
      } else if (numberOfSuggestedImage > 1 && numberOfSuggestedHeadline > 1) {
        numberOfSuggestedImageHeadline
        = newI18n.getString(
            _TL_('Suggested additional {{numberOfSuggestedImage}} images and {{numberOfSuggestedHeadline}} headlines'),
            { numberOfSuggestedImage, numberOfSuggestedHeadline }
          );
      } else if (numberOfSuggestedImage === 0 && numberOfSuggestedHeadline === 1) {
        numberOfSuggestedImageHeadline
        = newI18n.getString(
            _TL_('Suggested additional {{numberOfSuggestedHeadline}} headline'),
            { numberOfSuggestedHeadline }
          );
      } else if (numberOfSuggestedImage === 0 && numberOfSuggestedHeadline > 1) {
        numberOfSuggestedImageHeadline
        = newI18n.getString(
            _TL_('Suggested additional {{numberOfSuggestedHeadline}} headlines'),
            { numberOfSuggestedHeadline }
          );
      } else if (numberOfSuggestedImage === 1 && numberOfSuggestedHeadline === 0) {
        numberOfSuggestedImageHeadline
        = newI18n.getString(
            _TL_('Suggested additional {{numberOfSuggestedImage}} image'),
            { numberOfSuggestedImage }
          );
      } else if (numberOfSuggestedImage > 1 && numberOfSuggestedHeadline === 0) {
        numberOfSuggestedImageHeadline
        = newI18n.getString(
            _TL_('Suggested additional {{numberOfSuggestedImage}} images'),
            { numberOfSuggestedImage }
          );
      }
    }

    const pickProperities = {
      headlineCount: _.size(Headlines),
      textCount: _.size(Descriptions),
      imageCount: _.size(Images),
      Headline,
      Text: Description,
      landscapeImageMediaUrl,
      i18n: this.i18n,
      numberOfSuggestedImageHeadline,
      moreImages: withContextualAttributeTemplate({
        opportunityId: opportunity.OpportunityId,
        entityName: ` +${this.i18n.getString('Recommendation_Grid_Todo_More', { count: _.size(Images) - 1 })}`,
        entityId: `${opportunity.OpportunityId}_moreImages`,
        entityType: CONTEXTUAL_ENTITY_TYPE.MORE_IMAGES,
        status: 'false',
      }),
    };

    return _.defaults({
      OpportunityType,
    }, pickProperities);
  }

  get template() { return recommendedAdTemplate; }
}
